import { render, staticRenderFns } from "./Thread.vue?vue&type=template&id=260d5b16"
import script from "./Thread.vue?vue&type=script&lang=js"
export * from "./Thread.vue?vue&type=script&lang=js"
import style0 from "./Thread.vue?vue&type=style&index=0&id=260d5b16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports